import React from "react";
import "./Loading.scss";

const LoadingPage = () => {
  return (
    <div className=" fixed items-center justify-center  flex w-full h-full bg-gray-900 z-40  top-0 left-0">
      <div className=" text-center  ">
        <svg className="load" viewBox="0 0 50 50">
          <circle className="ring" cx="25" cy="25" r="20"></circle>
          <circle className="ball" cx="25" cy="5" r="3.5"></circle>
        </svg>
      </div>
    </div>
  );
};

export default LoadingPage;
